import { CHARADE_GREY, REGENT_GREY } from "../../../constants/colors";

const textColor = `${CHARADE_GREY}`;
const autopayTextColor = `${REGENT_GREY}`;

export const fallbackValues = {
  textColor,
  autopayTextColor
};
